import React from 'react';

import FD from './FOD/FD';
import OD from './FOD/OD';

function FODetails({file}) {
  return (
      <>
        <FD />
        <OD file={file} />
      </>
  );
}

export default FODetails;


